import React from 'react'
import strings from '../../../strings'
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonGrid, IonRow } from '@ionic/react'
import { getDirMode, isRTL } from '../../platform'

import './styles/audioTranscript.less'
import Button from 'mobile_web/modules/common/components/Button'

interface Props {
	transcript: string
	onBack: () => void
}

const AudioTranscript: React.FC<Props> = ({ transcript, onBack }) => (
	<IonCard dir={getDirMode()}>
		<IonCardHeader>
			<IonCardTitle id="dialogTitle">{strings.transcript}</IonCardTitle>
			{onBack && (
				<Button className="close" onClick={onBack} ariaLabel={strings.close}>
					<i className="fal fa-xmark" />
				</Button>
			)}
		</IonCardHeader>
		<IonCardContent>
			<IonGrid className="transcript-container" dir={isRTL() ? 'rtl' : 'ltr'}>
				<IonRow className="transcript">
					<div dangerouslySetInnerHTML={{ __html: transcript }} />
				</IonRow>
			</IonGrid>
		</IonCardContent>
	</IonCard>
)

export default AudioTranscript
